module.exports = __webpack_public_path__ + "img/Local-Clips-Option-2.8b8b972f.png";